// OptiMonk campaign 1: exit intent, >=15s on site, max 2 impressions,
// >=1 hour apart, stop after successful signup. No fake offer countdown.
const STATE_KEY = 'lt-popup-pop5fast-v1';
const SESSION_KEY = 'lt-popup-pop5fast-session-v1';
const PENDING_KEY = 'lt-popup-pop5fast-pending-v1';
export function calendarParts(timestamp) {
  const parts = new Intl.DateTimeFormat('en-GB', {timeZone:'Europe/Bucharest',year:'numeric',month:'numeric',day:'numeric'}).formatToParts(timestamp);
  const get = (name) => Number(parts.find(p => p.type === name).value);
  return {year:get('year'),month:get('month'),day:get('day')};
}
export function lastWeekOfMonth(timestamp, days=7) {
  const {year,month,day}=calendarParts(timestamp);
  return day > new Date(Date.UTC(year,month,0)).getUTCDate() - days;
}
export function popupConfig(data={}) {
  const number=(name,fallback,min,max) => {
    const value=data[name] === undefined || data[name] === '' ? fallback : Number(data[name]);
    return Number.isFinite(value) ? Math.min(max,Math.max(min,value)) : fallback;
  };
  return {schedule:data.schedule==='always'?'always':'month_end',lastDays:number('lastDays',7,1,28),delay:number('delay',15,0,120),maxViews:number('maxViews',2,1,10),gapHours:number('gapHours',1,1,72),frequencyPeriod:data.frequencyPeriod==='monthly'?'monthly':'lifetime',desktopExit:data.desktopExit!=='false',mobileScroll:data.mobileScroll!=='false',mobileReturn:data.mobileReturn!=='false'};
}
export function periodKey(timestamp) {
  const {year,month}=calendarParts(timestamp);return `${year}-${month}`;
}
export function inSchedule(timestamp, config=popupConfig()) {
  return config.schedule==='always' || lastWeekOfMonth(timestamp,config.lastDays);
}
export function eligible(timestamp, state, enteredAt, config=popupConfig()) {
  const period=periodKey(timestamp);
  // Historical impressions belong to their actual month when monthly limits are enabled.
  const count=config.frequencyPeriod==='monthly'
    ? (state.month===period ? state.monthCount || 0 : (!state.month && state.lastShown && periodKey(state.lastShown)===period ? state.count || 0 : 0))
    : state.count || 0;
  return inSchedule(timestamp,config) && !state.converted && count < config.maxViews &&
    timestamp - enteredAt >= config.delay*1000 && (!state.lastShown || timestamp - state.lastShown >= config.gapHours*3600000);
}
const Base = typeof HTMLElement === 'undefined' ? class {} : HTMLElement;
export class MonthEndPopup extends Base {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.config = popupConfig(this.dataset);
    this.dialog = this.querySelector('dialog');
    this.form = this.querySelector('form');
    try { this.storage = window.localStorage; this.storage.setItem(STATE_KEY+'-check','1'); this.storage.removeItem(STATE_KEY+'-check'); } catch { return; }
    this.abort = new AbortController();
    const options = {signal:this.abort.signal};
    this.form.querySelectorAll('input[required]').forEach(input => {
      input.addEventListener('input',() => input.setCustomValidity(''),options);
      input.addEventListener('invalid',() => input.setCustomValidity(input.type === 'email' ? 'Completează o adresă de e-mail validă.' : 'Bifează acordul pentru a primi noutăți și codul de reducere.'),options);
    });
    this.querySelectorAll('[data-close]').forEach(b => b.addEventListener('click',() => this.close(),options));
    this.dialog.addEventListener('close',() => { this.previousFocus?.focus?.({preventScroll:true}); },options);
    this.dialog.addEventListener('click',e => { if (e.target === this.dialog) { const r=this.dialog.getBoundingClientRect(); if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom) this.close(); } },options);
    this.form.addEventListener('submit',event => {
      if(this.dataset.designMode==='true') {
        event.preventDefault();this.querySelector('.lt-offer__status').textContent='Probă în editor: nu trimitem înscrieri. Alege «Confirmare și cod» din setări pentru a vedea pasul următor.';return;
      }
      // Only remember a pending request. Do not count it as a conversion until Shopify confirms success.
      sessionStorage.setItem(PENDING_KEY,JSON.stringify({at:Date.now(),path:location.pathname}));
    },options);
    let pending;
    try { pending = JSON.parse(sessionStorage.getItem(PENDING_KEY)); } catch { /* no pending form */ }
    if (this.dataset.designMode !== 'true' && pending && Date.now()-pending.at < 1800000 && this.querySelector('[data-server-success]')) {
      this.save({...this.state(),converted:true});
      sessionStorage.removeItem(PENDING_KEY);
      this.success(); this.show(false);
    } else if (pending && this.querySelector('[data-server-error]')) this.show(false);
    if (this.dataset.designMode === 'true') {
      this.querySelector('[data-apply]')?.addEventListener('click',event=>event.preventDefault(),options);
      if(this.dataset.editorPreview === 'true') {
        if(this.dataset.previewStage==='success') this.success();
        this.show(false);
      }
      return;
    }
    this.refreshClock();
    document.addEventListener('mouseout',e => {
      if (this.config.desktopExit && !e.relatedTarget && e.clientY <= 0 && matchMedia('(hover: hover) and (pointer: fine)').matches) this.tryShow();
    },options);
    // Mobile exit signals: returning from another tab or rapid upward scrolling.
    // Never trap the Back button or add artificial browser-history entries.
    const scrollStates=new WeakMap();
    const onScroll=event => {
      const target=event.target===document || event.target===window ? document.scrollingElement : event.target;
      if(!target || target.closest?.('dialog, [role="dialog"]')) return;
      const y=target.scrollTop || 0,at=performance.now();
      const previous=scrollStates.get(target)||{lastY:y,highestY:y,upStartY:y,upStartAt:at};
      let {lastY,highestY,upStartY,upStartAt}=previous;highestY=Math.max(highestY,y);
      if(y>=lastY || at-upStartAt>400) { upStartY=lastY;upStartAt=at; }
      if(this.config.mobileScroll && matchMedia('(pointer: coarse)').matches && highestY>250 && upStartY-y>180 && at-upStartAt<400 && y<150) this.tryShow();
      scrollStates.set(target,{lastY:y,highestY,upStartY,upStartAt});
    };
    // Capture scrolls from the theme's own page scroller as well as document scrolling.
    document.addEventListener('scroll',onScroll,{...options,passive:true,capture:true});
    document.addEventListener('visibilitychange',() => {
      if(document.hidden) this.wasHidden=true;
      else if(this.wasHidden) { this.wasHidden=false; if(this.config.mobileReturn && matchMedia('(pointer: coarse)').matches) this.tryShow(); }
    },options);
    document.addEventListener('visitorConsentCollected',() => {
      if (!this.marketingAllowed()) this.close();
    },options);
    this.timer=setInterval(() => {
      if(this.dialog.open && !this.querySelector('[data-success]').hidden) return;
      if(this.dialog.open && this.serverTime && !inSchedule(this.now(),this.config)) this.close();
    },1000);
  }
  state() { try { const s=JSON.parse(this.storage.getItem(STATE_KEY)); return s && typeof s==='object' ? s : {}; } catch { return {}; } }
  save(value) { try { this.storage.setItem(STATE_KEY,JSON.stringify(value)); } catch { /* fail closed on the next eligibility check */ } }
  marketingAllowed() { return window.Shopify?.customerPrivacy?.marketingAllowed?.() === true; }
  now() { return this.serverTime + performance.now()-this.clockAt; }
  async refreshClock() {
    if(this.clockRequest) return this.clockRequest;
    this.clockRequest = (async () => {
      try {
        const response=await fetch(`${window.Shopify?.routes?.root || '/'}?lt_offer_clock=${Date.now()}`,{method:'HEAD',cache:'no-store',credentials:'same-origin',signal:AbortSignal.timeout(8000)});
        const timestamp=Date.parse(response.headers.get('date'));
        if(!response.ok || !Number.isFinite(timestamp)) return false;
        this.serverTime=timestamp; this.clockAt=performance.now();
        const existing=Number(sessionStorage.getItem(SESSION_KEY));
        this.enteredAt=existing>0 && existing<=timestamp ? existing : timestamp;
        sessionStorage.setItem(SESSION_KEY,String(this.enteredAt));
        return true;
      } catch { return false; } finally { this.clockRequest=null; }
    })();
    return this.clockRequest;
  }
  async tryShow() {
    if(this.busy || this.dialog.open || !this.marketingAllowed() || document.hidden) return;
    this.busy=true;
    try {
      if(!this.serverTime || performance.now()-this.clockAt>60000) if(!await this.refreshClock()) return;
      if(!eligible(this.now(),this.state(),this.enteredAt,this.config)) return;
      if(document.querySelector('dialog[open], [role="dialog"][aria-modal="true"]')) return;
      const active=document.activeElement;
      if(active?.matches('input,textarea,select,[contenteditable="true"]')) return;
      this.show(true);
    } finally { this.busy=false; }
  }
  show(count) {
    if(this.dialog.open) return;
    this.previousFocus=document.activeElement;
    const image=this.querySelector('img[data-src]'); if(image && !image.src) image.src=image.dataset.src;
    this.dialog.showModal();
    this.querySelector('.lt-offer__close').focus({preventScroll:true});
    if(count) {
      const s=this.state(),timestamp=this.now(),month=periodKey(timestamp);
      const monthCount=s.month===month?s.monthCount||0:(!s.month&&s.lastShown&&periodKey(s.lastShown)===month?s.count||0:0);
      this.save({...s,count:(s.count||0)+1,lastShown:timestamp,month,monthCount:monthCount+1});
    }
  }
  success() { this.querySelector('[data-signup]').hidden=true; this.querySelector('[data-success]').hidden=false; this.querySelector('h2').textContent=this.dataset.successTitle || 'Un pas mai aproape.'; }
  close() { if(this.dialog?.open) this.dialog.close(); }
  disconnectedCallback() { this.abort?.abort(); clearInterval(this.timer); this.ready=false; }
}
if(typeof customElements!=='undefined'&&!customElements.get('lt-month-end-popup')) customElements.define('lt-month-end-popup',MonthEndPopup);
